export function notNull<TValue>(
  param: TValue,
  name: string,
): asserts param is NonNullable<TValue> {
  if (!param) {
    throw new Error(`'${name}' is null or undefined.`);
  }
}
